(function () {
  var root = document.querySelector('[data-vna-cart-drawer-root][data-enabled="true"]');
  if (!root) return;

  var drawer = root.querySelector('.vna-cart-drawer');
  var itemsNode = root.querySelector('[data-vna-cart-items]');
  var recModal = root.querySelector('[data-vna-rec-modal]');
  var moneyFormat = root.dataset.moneyFormat || '¥{{amount_no_decimals}}';
  var countryCode = (root.dataset.countryCode || '').toUpperCase();
  var cartCurrencyCode = (root.dataset.cartCurrency || '').toUpperCase();
  var shopCurrencyCode = (root.dataset.shopCurrency || 'JPY').toUpperCase();
  var freeShippingThreshold = Number(root.dataset.freeShippingThreshold || 0);
  var freeShippingRuleAmount = Number(root.dataset.freeShippingRuleAmount || 0);
  var freeShippingRuleCurrency = (root.dataset.freeShippingRuleCurrency || cartCurrencyCode || shopCurrencyCode).toUpperCase();
  var giftThreshold = Number(root.dataset.giftThreshold || 0);
  var giftVariantId = root.dataset.giftVariantId || '';
  var freeShippingLeftText = root.dataset.freeShippingLeftText || '';
  var freeShippingRightText = root.dataset.freeShippingRightText || '';
  var freeShippingCompleteText = root.dataset.freeShippingCompleteText || '';
  var giftNotReachedText = root.dataset.giftNotReachedText || '';
  var giftReachedText = root.dataset.giftReachedText || '';
  var giftAddedText = root.dataset.giftAddedText || '';
  var giftReachedButtonText = root.dataset.giftReachedButtonText || '';
  var giftDisabledButtonText = root.dataset.giftDisabledButtonText || '';
  var bridgeInstallCount = 0;
  var inventoryCache = Object.create(null);
  var settleRefreshToken = 0;
  var cartRecoveryTimer = null;
  var cartAddBridgeRefreshTimer = null;
  var cartFetchBackoffUntil = 0;
  var internalCartAddRequests = 0;
  var toolStatusTimers = Object.create(null);
  var cartStatusTimer = null;
  var cartMutationQueue = Promise.resolve();
  var displayedItemCount = parseInt((root.querySelector('[data-vna-cart-count]') || {}).textContent || '0', 10) || 0;
  var displayedSummary = { subtotal: 0, total: 0, discount: 0 };
  var lastCart = null;
  var fallbackRatesPerShopCurrency = {
    JPY: 1,
    USD: 0.0063966648,
    HKD: 0.0499,
    MOP: 0.0514,
    EUR: 0.0059,
    GBP: 0.005,
    CAD: 0.0088,
    AUD: 0.0097,
    SGD: 0.0082,
    TWD: 0.193,
    CNY: 0.0455,
    KRW: 8.72,
    THB: 0.235,
    MYR: 0.0302,
    PHP: 0.366,
    NZD: 0.0105
  };
  var recState = {
    product: null,
    options: [],
    quantity: 1,
    variant: null,
    sourceButton: null
  };
  var i18n = {};

  try {
    var i18nNode = root.querySelector('[data-vna-cart-i18n]');
    if (i18nNode && i18nNode.textContent) i18n = JSON.parse(i18nNode.textContent);
  } catch (error) {
    i18n = {};
  }

  function t(key, fallback) {
    return i18n[key] || fallback || key;
  }

  function interpolate(template, values) {
    return String(template || '').replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, key) {
      return values && values[key] != null ? values[key] : '';
    });
  }

  function itemCountText(count) {
    var quantity = Math.max(Number(count || 0), 0);
    var template = quantity === 1 ? t('itemCountOne', '{{ count }} item') : t('itemCountOther', '{{ count }} items');
    return interpolate(template, { count: quantity });
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }
    return '¥' + Math.round(Number(cents || 0) / 100).toLocaleString('ja-JP');
  }

  function currencyCode(value) {
    return String(value || '').trim().toUpperCase();
  }

  function activeCurrencyCode(cart) {
    return currencyCode(
      (cart && cart.currency) ||
      cartCurrencyCode ||
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
      shopCurrencyCode
    );
  }

  function ratePerShopCurrency(currency) {
    var code = currencyCode(currency);
    if (!code || code === shopCurrencyCode) return 1;

    var shopifyCurrency = window.Shopify && window.Shopify.currency;
    if (shopifyCurrency && currencyCode(shopifyCurrency.active) === code) {
      var activeRate = Number(shopifyCurrency.rate);
      if (activeRate > 0) return activeRate;
    }

    return fallbackRatesPerShopCurrency[code] || 0;
  }

  function convertMajorAmount(amount, sourceCurrency, targetCurrency) {
    var value = Number(amount || 0);
    var source = currencyCode(sourceCurrency);
    var target = currencyCode(targetCurrency);
    if (!value || !source || !target || source === target) return value;

    var sourceRate = ratePerShopCurrency(source);
    var targetRate = ratePerShopCurrency(target);
    if (!sourceRate || !targetRate) return value;

    return (value / sourceRate) * targetRate;
  }

  function currentFreeShippingThreshold(cart) {
    var targetCurrency = activeCurrencyCode(cart);
    var sourceCurrency = freeShippingRuleCurrency;
    var sourceAmount = freeShippingRuleAmount || (freeShippingThreshold / 100);
    var convertedAmount = convertMajorAmount(sourceAmount, sourceCurrency, targetCurrency);
    var convertedThreshold = Math.round(convertedAmount * 100);

    return convertedThreshold > 0 ? convertedThreshold : freeShippingThreshold;
  }

  function shippingText(template, amount) {
    return String(template || '[amount]').replace(/\[amount\]/g, amount);
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (char) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char];
    });
  }

  function route(path) {
    var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return rootUrl.replace(/\/?$/, '/') + String(path || '').replace(/^\//, '');
  }

  function safeStorage() {
    try {
      return window.localStorage;
    } catch (error) {
      return null;
    }
  }

  function isDrawerOpen() {
    return document.body.classList.contains('vna-cart-drawer-open');
  }

  function closeLegacyCart() {
    document.body.classList.remove('cart-sidebar-show', 'add-to-cart-show');
  }

  function closeLegacyPopups() {
    closeLegacyCart();
    document.body.classList.remove('quickshop-popup-show', 'quick-view-show', 'quick_shop_popup_mobile');
  }

  function openDrawer(options) {
    closeLegacyCart();
    document.body.classList.add('vna-cart-drawer-open');
    if (drawer) drawer.setAttribute('aria-hidden', 'false');
    if (!options || options.refresh !== false) refreshCart();
  }

  function closeDrawer() {
    closeGiftModal();
    closeRecModal();
    closeLegacyCart();
    closeToolPanels();
    document.body.classList.remove('vna-cart-drawer-open');
    if (drawer) drawer.setAttribute('aria-hidden', 'true');
  }

  function recoverLineInteractivity(item) {
    if (!item) return;
    item.classList.remove('is-pricing-pending');
    setLinePending(item, false);
  }

  function cartError(message, userMessage, status) {
    var error = new Error(message || userMessage || 'Cart request failed');
    error.userMessage = userMessage || t('cartUpdateError', 'Cart could not be updated. Please wait a moment and try again.');
    if (status) error.status = Number(status);
    return error;
  }

  function isCartAccessBlocked(error) {
    var message = error && String(error.message || error.userMessage || '');
    return Boolean(error && (error.status === 403 || error.status === 429 || /403|Forbidden/i.test(message)));
  }

  function isCartFetchBackoffActive() {
    return Date.now() < cartFetchBackoffUntil;
  }

  function markCartBackoff(error) {
    if (!isCartAccessBlocked(error)) return;
    cartFetchBackoffUntil = Math.max(cartFetchBackoffUntil, Date.now() + 3500);
  }

  function clearCartBackoff() {
    cartFetchBackoffUntil = 0;
  }

  function cartBackoffError(userMessage) {
    var error = cartError('Cart refresh paused after a blocked request', userMessage, 429);
    error.isCartBackoff = true;
    return error;
  }

  function userCartMessage(error, fallback) {
    var message = error && (error.userMessage || error.message);
    if (!message || /Unexpected token|DOCTYPE|not valid JSON|JSON|SyntaxError/i.test(message)) {
      return fallback || t('cartUpdateError', 'Cart could not be updated. Please wait a moment and try again.');
    }
    return message;
  }

  function parseJsonResponse(response, fallbackMessage) {
    return response.text().then(function (text) {
      var data = {};

      if (text) {
        try {
          data = JSON.parse(text);
        } catch (error) {
          throw cartError('Cart endpoint returned non-JSON response', fallbackMessage, response.status);
        }
      }

      if (!response.ok) {
        throw cartError(
          data.description || data.message || fallbackMessage,
          data.description || data.message || fallbackMessage,
          response.status
        );
      }

      clearCartBackoff();
      return data;
    });
  }

  function delay(ms) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, ms);
    });
  }

  function withTimeout(promise, ms, userMessage) {
    var timer = null;
    var timeout = new Promise(function (_, reject) {
      timer = window.setTimeout(function () {
        reject(cartError('Cart request timed out', userMessage));
      }, ms || 12000);
    });

    return Promise.race([promise, timeout]).finally(function () {
      if (timer) window.clearTimeout(timer);
    });
  }

  function enqueueCartMutation(task) {
    var queued = cartMutationQueue.catch(function () {}).then(function () {
      return task();
    });
    cartMutationQueue = queued.catch(function () {});
    return queued;
  }

  function fetchCart(retry) {
    if (isCartFetchBackoffActive()) {
      return Promise.reject(cartBackoffError(t('cartUpdateError', 'Cart could not be updated. Please wait a moment and try again.')));
    }

    return fetch(route('cart.js'), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    }).then(function (response) {
      return parseJsonResponse(response, t('cartUpdateError', 'Cart could not be updated. Please wait a moment and try again.'));
    }).catch(function (error) {
      markCartBackoff(error);
      if (retry === false || isCartAccessBlocked(error)) throw error;
      return delay(420).then(function () { return fetchCart(false); });
    });
  }

  function fetchInternalCartAdd(options) {
    internalCartAddRequests += 1;
    return fetch(route('cart/add.js'), options).finally(function () {
      internalCartAddRequests = Math.max(internalCartAddRequests - 1, 0);
    });
  }

  function refreshCartAfterAdd() {
    return refreshCart().catch(function (error) {
      markCartBackoff(error);
      if (isCartAccessBlocked(error)) {
        setCartStatus(t('cartUpdateError', 'Cart could not be updated. Please wait a moment and try again.'), 'error');
      } else {
        scheduleCartSettleRefresh();
      }
      return lastCart;
    });
  }

  function changeLine(key, quantity) {
    return fetch(route('cart/change.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      cache: 'no-store',
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (response) {
      return parseJsonResponse(response, t('cartUpdateError', 'Cart could not be updated. Please wait a moment and try again.'));
    }).catch(function (error) {
      markCartBackoff(error);
      throw error;
    });
  }

  function updateLines(updates) {
    return fetch(route('cart/update.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      cache: 'no-store',
      body: JSON.stringify({ updates: updates })
    }).then(function (response) {
      return parseJsonResponse(response, t('cartUpdateError', 'Cart could not be updated. Please wait a moment and try again.'));
    }).catch(function (error) {
      markCartBackoff(error);
      throw error;
    });
  }

  function addVariant(variantId, quantity) {
    var requestedQuantity = Math.max(Number(quantity || 1), 1);
    var id = Number(variantId);

    return enqueueCartMutation(function () {
      return withTimeout(
        fetchInternalCartAdd({
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          cache: 'no-store',
          body: JSON.stringify({ items: [{ id: id, quantity: requestedQuantity }] })
        })
          .then(function (response) {
            return parseJsonResponse(response, t('addToCartError', 'Could not add this item to cart. Please wait a moment and try again.'));
          })
          .then(refreshCartAfterAdd),
        15000,
        t('addToCartError', 'Could not add this item to cart. Please wait a moment and try again.')
      );
    });
  }

  function updateCartCount(count) {
    displayedItemCount = Math.max(Number(count || 0), 0);
    root.querySelectorAll('[data-vna-cart-count]').forEach(function (node) {
      node.textContent = itemCountText(displayedItemCount);
    });
    document.querySelectorAll('[data-cart-count], .cart-count-bubble .text').forEach(function (node) {
      node.textContent = displayedItemCount > 99 ? '99+' : displayedItemCount;
    });
    document.querySelectorAll('.cart-count-bubble .visually-hidden, .cart-count-bubble [aria-hidden="false"]').forEach(function (node) {
      node.textContent = itemCountText(displayedItemCount);
    });
    document.querySelectorAll('a[href$="/cart"], a[href="/cart"]').forEach(function (link) {
      if (/cart/i.test((link.getAttribute('aria-label') || '') + ' ' + (link.getAttribute('href') || ''))) {
        link.setAttribute('aria-label', interpolate(t('cartAriaLabel', 'Cart {{ count }} items'), { count: displayedItemCount }));
      }
    });
  }

  function setCartCalculating(active) {
    root.classList.toggle('is-cart-calculating', Boolean(active));
  }

  function setCartStatus(message, state) {
    var status = root.querySelector('[data-vna-cart-status]');
    if (!status) return;
    status.textContent = message || '';
    status.dataset.state = state || '';

    if (cartStatusTimer) window.clearTimeout(cartStatusTimer);
    if (message) {
      cartStatusTimer = window.setTimeout(function () {
        status.textContent = '';
        status.dataset.state = '';
      }, 3600);
    }
  }

  function scheduleCartSettleRefresh(delayMs) {
    var token = ++settleRefreshToken;
    var wait = Number(delayMs || 1400);
    setCartCalculating(true);

    if (cartRecoveryTimer) window.clearTimeout(cartRecoveryTimer);
    if (isCartFetchBackoffActive()) {
      wait = Math.max(wait, cartFetchBackoffUntil - Date.now() + 250);
    }

    cartRecoveryTimer = window.setTimeout(function () {
      if (token !== settleRefreshToken) return;
      refreshCart()
        .catch(function (error) {
          markCartBackoff(error);
          if (isCartAccessBlocked(error)) {
            setCartStatus(t('cartUpdateError', 'Cart could not be updated. Please wait a moment and try again.'), 'error');
          }
        })
        .finally(function () {
          if (token === settleRefreshToken) setCartCalculating(false);
        });
    }, wait);
  }

  function setToolStatus(type, message, state) {
    var status = root.querySelector('[data-vna-' + type + '-status]');
    if (!status) return;
    status.textContent = message || '';
    status.dataset.state = state || '';

    if (toolStatusTimers[type]) window.clearTimeout(toolStatusTimers[type]);
    if (message && state !== 'loading') {
      toolStatusTimers[type] = window.setTimeout(function () {
        status.textContent = '';
        status.dataset.state = '';
      }, 3600);
    }
  }

  function setToolLoading(type, active) {
    var panel = root.querySelector('[data-vna-tool-panel="' + type + '"]');
    var button = root.querySelector(type === 'coupon' ? '[data-vna-coupon-apply]' : '[data-vna-note-save]');
    if (panel) panel.classList.toggle('is-loading', Boolean(active));
    if (button) {
      button.disabled = Boolean(active);
      button.classList.toggle('is-loading', Boolean(active));
    }
  }

  function normalizeWishlistEntry(entry) {
    if (!entry) return null;
    if (typeof entry === 'string') return entry ? { handle: entry } : null;
    var url = entry.url || entry.productUrl || entry.href || '';
    var handle = entry.handle || entry.productHandle || entry.product_handle || entry.slug || '';
    if (!handle && url.indexOf('/products/') !== -1) {
      handle = url.split('/products/')[1].split(/[?#/]/)[0];
    }
    if (!handle) return null;
    return {
      handle: String(handle),
      id: entry.id || entry.productId || '',
      title: entry.title || entry.productTitle || '',
      url: url || ('/products/' + handle),
      image: entry.image || entry.featuredImage || '',
      price: entry.price || ''
    };
  }

  function parseWishlistValue(value) {
    if (!value) return [];
    try {
      var parsed = JSON.parse(value);
      if (Array.isArray(parsed)) return parsed.map(normalizeWishlistEntry).filter(Boolean);
      if (typeof parsed === 'string') return [normalizeWishlistEntry(parsed)].filter(Boolean);
      if (parsed && typeof parsed === 'object') {
        return Object.keys(parsed).map(function (key) {
          return normalizeWishlistEntry(parsed[key]) || normalizeWishlistEntry(key);
        }).filter(Boolean);
      }
    } catch (error) {
      return String(value).split(/[,|]/).map(function (handle) {
        return normalizeWishlistEntry(handle.trim());
      }).filter(Boolean);
    }
    return [];
  }

  function readWishlist() {
    var storage = safeStorage();
    var entries = [];
    var seen = Object.create(null);
    if (!storage) return entries;

    ['vna:wishlist', 'wishlistList', 'halo-wishlist', 'wishList', 'wishlist'].forEach(function (key) {
      parseWishlistValue(storage.getItem(key)).forEach(function (entry) {
        if (!seen[entry.handle]) {
          seen[entry.handle] = true;
          entries.push(entry);
        }
      });
    });

    return entries;
  }

  function writeWishlist(entries) {
    var storage = safeStorage();
    if (!storage) return;
    var cleanEntries = [];
    var seen = Object.create(null);

    entries.forEach(function (entry) {
      entry = normalizeWishlistEntry(entry);
      if (entry && !seen[entry.handle]) {
        seen[entry.handle] = true;
        cleanEntries.push(entry);
      }
    });

    var handles = cleanEntries.map(function (entry) { return entry.handle; });
    storage.setItem('vna:wishlist', JSON.stringify(cleanEntries));
    storage.setItem('wishlistItem', JSON.stringify(handles));
    storage.setItem('wishlistList', JSON.stringify(handles));
    storage.setItem('halo-wishlist', JSON.stringify(handles));
    if (storage.getItem('wishlist') != null) storage.setItem('wishlist', JSON.stringify(handles));
  }

  function updateWishlistCount(count) {
    document.querySelectorAll('[data-wishlist-count]').forEach(function (node) {
      node.textContent = count > 0 ? count : '';
    });
  }

  function syncWishlistButtons() {
    var handles = readWishlist().map(function (entry) { return entry.handle; });
    var lookup = Object.create(null);
    handles.forEach(function (handle) { lookup[handle] = true; });
    updateWishlistCount(handles.length);

    root.querySelectorAll('[data-vna-wishlist-toggle]').forEach(function (button) {
      var active = Boolean(lookup[button.dataset.productHandle]);
      button.classList.toggle('is-active', active);
      button.classList.toggle('wishlist-added', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.setAttribute('aria-label', (button.dataset.productTitle || 'Product') + ' ' + (active ? t('removeFromWishlist', 'remove from wishlist') : t('addToWishlist', 'add to wishlist')));
    });
  }

  function toggleWishlist(button) {
    var handle = button && button.dataset.productHandle;
    if (!handle) return;
    var entries = readWishlist();
    var exists = entries.some(function (entry) { return entry.handle === handle; });

    if (exists) {
      entries = entries.filter(function (entry) { return entry.handle !== handle; });
    } else {
      entries.push({
        handle: handle,
        id: button.dataset.productId || '',
        title: button.dataset.productTitle || '',
        url: button.dataset.productUrl || ('/products/' + handle),
        image: button.dataset.productImage || '',
        price: button.dataset.productPrice || ''
      });
    }

    writeWishlist(entries);
    syncWishlistButtons();
    window.dispatchEvent(new CustomEvent('vna:wishlist:change', {
      detail: { handle: handle, added: !exists, items: entries }
    }));
    document.dispatchEvent(new CustomEvent('wishlist:updated', {
      detail: { handle: handle, added: !exists, items: entries }
    }));
  }

  function lineDiscountAmount(item) {
    return Math.max(Number(item.original_line_price || 0) - Number(item.final_line_price || item.line_price || 0), 0);
  }

  function renderLinePrices(item) {
    var original = Number(item.original_line_price || item.line_price || item.final_line_price || 0);
    var finalPrice = Number(item.final_line_price || item.line_price || 0);
    return [
      '<div class="vna-cart-item__prices">',
        original > finalPrice ? '<s>' + formatMoney(original) + '</s>' : '',
        '<span>' + formatMoney(finalPrice) + '</span>',
      '</div>'
    ].join('');
  }

  function renderLineDiscounts(item) {
    var allocations = item.line_level_discount_allocations || [];
    var rows = allocations.map(function (allocation) {
      var title = allocation.discount_application && allocation.discount_application.title
        ? allocation.discount_application.title
        : (allocation.title || t('discount', 'Discount'));
      return '<li data-vna-discount-title="' + escapeHtml(title) + '">' + escapeHtml(title) + '</li>';
    });

    if (!rows.length && Number(item.original_line_price || 0) > Number(item.final_line_price || 0)) {
      rows.push('<li data-vna-discount-title="' + escapeHtml(t('discount', 'Discount')) + '">' + escapeHtml(t('discount', 'Discount')) + '</li>');
    }

    return rows.length ? '<ul class="vna-cart-item__discounts">' + rows.join('') + '</ul>' : '';
  }

  function productHandleFromItem(item) {
    if (item && item.handle) return item.handle;
    var url = item && item.url ? item.url : '';
    var match = String(url).match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function normalizedMaxQuantity(value) {
    if (value === null || value === undefined || value === '') return null;
    var quantity = Number(value);
    return Number.isFinite(quantity) && quantity >= 0 ? quantity : null;
  }

  function isAtMaxQuantity(quantity, maxQuantity) {
    var max = normalizedMaxQuantity(maxQuantity);
    return max !== null && Number(quantity || 0) >= max;
  }

  function inventoryStateForCartItem(item) {
    var variantId = item && item.variant_id ? String(item.variant_id) : '';
    return variantId ? inventoryCache[variantId] || null : null;
  }

  function rememberInventoryState(variantId, maxQuantity, managed, policy, handle) {
    var id = variantId != null ? String(variantId) : '';
    if (!id) return;

    var max = normalizedMaxQuantity(maxQuantity);
    if (max === null || !managed || policy === 'continue') {
      delete inventoryCache[id];
      return;
    }

    inventoryCache[id] = {
      maxQuantity: max,
      managed: Boolean(managed),
      policy: policy || '',
      handle: handle || ''
    };
  }

  function rememberInventoryPayload(detail) {
    var variants = detail && detail.variants;
    if (!Array.isArray(variants)) return;

    variants.forEach(function (variant) {
      var variantId = variant.variantId != null ? variant.variantId : variant.id;
      var managed = variant.managed != null ? Boolean(variant.managed) : Boolean(variant.inventory_management);
      var policy = variant.policy || variant.inventory_policy || '';
      var maxQuantity = variant.maxQuantity != null ? variant.maxQuantity : variant.inventory_quantity;
      rememberInventoryState(variantId, maxQuantity, managed, policy, variant.handle || '');
    });

    applyAllLineMaxStates();
  }

  function cartQuantityByVariant(cart) {
    var totals = Object.create(null);
    ((cart && cart.items) || []).forEach(function (item) {
      var variantId = item && item.variant_id != null ? String(item.variant_id) : '';
      if (!variantId) return;
      totals[variantId] = (totals[variantId] || 0) + Number(item.quantity || 0);
    });
    return totals;
  }

  function lineMaxQuantity(currentQuantity, maxQuantity, variantTotalQuantity) {
    var max = normalizedMaxQuantity(maxQuantity);
    if (max === null) return null;
    var current = Number(currentQuantity || 0);
    var total = Number(variantTotalQuantity);
    if (!Number.isFinite(total)) total = current;
    var otherLinesQuantity = Math.max(total - current, 0);
    return Math.max(max - otherLinesQuantity, 0);
  }

  function visibleProperties(item) {
    var props = item && item.properties;
    var pairs = [];
    if (!props) return pairs;

    if (Array.isArray(props)) {
      props.forEach(function (prop) {
        var name = prop && (prop.name || prop[0]);
        var value = prop && (prop.value || prop[1]);
        if (!name || String(name).charAt(0) === '_' || value === '' || value == null) return;
        pairs.push([String(name), String(value)]);
      });
      return pairs;
    }

    Object.keys(props).forEach(function (name) {
      var value = props[name];
      if (!name || String(name).charAt(0) === '_' || value === '' || value == null) return;
      pairs.push([String(name), String(value)]);
    });
    return pairs;
  }

  function lineSellingPlanId(item) {
    var allocation = item && item.selling_plan_allocation;
    return allocation && allocation.selling_plan ? String(allocation.selling_plan.id || '') : '';
  }

  function lineFinalUnitPrice(item) {
    var quantity = Math.max(Number(item && item.quantity || 1), 1);
    if (item && item.final_price != null) return Number(item.final_price || 0);
    return Math.round(Number(item && (item.final_line_price || item.line_price) || 0) / quantity);
  }

  function lineMergeKey(item) {
    return JSON.stringify({
      product: item.product_id || productHandleFromItem(item),
      variant: item.variant_id || '',
      variantTitle: item.variant_title || '',
      sellingPlan: lineSellingPlanId(item),
      finalUnitPrice: lineFinalUnitPrice(item),
      properties: visibleProperties(item).sort(function (a, b) {
        return (a[0] + ':' + a[1]).localeCompare(b[0] + ':' + b[1]);
      })
    });
  }

  function discountTitle(allocation) {
    return allocation && allocation.discount_application && allocation.discount_application.title
      ? allocation.discount_application.title
      : ((allocation && allocation.title) || t('discount', 'Discount'));
  }

  function cartDiscountTitles(cart) {
    var titles = [];
    var seen = Object.create(null);

    function add(application) {
      if (application && application.discount_application) {
        application = application.discount_application;
      }
      var title = String((application && (application.title || application.code)) || '').trim();
      var key = title.toLocaleLowerCase();
      if (!title || seen[key]) return;
      seen[key] = true;
      titles.push(title);
    }

    [].concat(cart.cart_level_discount_applications || [], cart.discount_applications || []).forEach(add);
    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (allocation) {
        add(allocation && (allocation.discount_application || allocation));
      });
    });

    return titles;
  }

  function mergeLineDiscounts(items, fallbackItem) {
    var byTitle = Object.create(null);
    items.forEach(function (line) {
      (line.line_level_discount_allocations || []).forEach(function (allocation) {
        var title = discountTitle(allocation);
        if (!byTitle[title]) {
          byTitle[title] = {
            title: title,
            amount: 0,
            discount_application: { title: title }
          };
        }
        byTitle[title].amount += Number(allocation.amount || 0);
      });
    });

    if (!Object.keys(byTitle).length && Number(fallbackItem.original_line_price || 0) > Number(fallbackItem.final_line_price || 0)) {
      byTitle[t('discount', 'Discount')] = {
        title: t('discount', 'Discount'),
        amount: lineDiscountAmount(fallbackItem),
        discount_application: { title: t('discount', 'Discount') }
      };
    }

    return Object.keys(byTitle).map(function (title) { return byTitle[title]; });
  }

  function mergeCartItems(cart) {
    var groups = [];
    var lookup = Object.create(null);

    ((cart && cart.items) || []).forEach(function (item) {
      var key = lineMergeKey(item);
      var group = lookup[key];
      if (!group) {
        group = Object.assign({}, item, {
          quantity: 0,
          original_line_price: 0,
          final_line_price: 0,
          line_price: 0,
          total_discount: 0,
          _vnaLines: []
        });
        lookup[key] = group;
        groups.push(group);
      }

      group.quantity += Number(item.quantity || 0);
      group.original_line_price += Number(item.original_line_price || item.line_price || 0);
      group.final_line_price += Number(item.final_line_price || item.line_price || 0);
      group.line_price += Number(item.line_price || item.final_line_price || 0);
      group.total_discount += Number(item.total_discount || 0);
      group._vnaLines.push({
        key: item.key,
        quantity: Number(item.quantity || 0)
      });
    });

    groups.forEach(function (group) {
      group.line_level_discount_allocations = mergeLineDiscounts(
        group._vnaLines.map(function (line) {
          return ((cart && cart.items) || []).find(function (item) { return item.key === line.key; }) || {};
        }),
        group
      );
    });

    return groups;
  }

  function renderItems(cart) {
    if (!itemsNode) return;
    if (!cart.items.length) {
      itemsNode.innerHTML = '<p class="vna-cart-drawer__empty" data-vna-cart-empty>' + escapeHtml(t('empty', 'Your cart is empty.')) + '</p>';
      return;
    }

    var variantTotals = cartQuantityByVariant(cart);
    itemsNode.innerHTML = mergeCartItems(cart).map(function (item) {
      var variant = item.variant_title && item.variant_title !== 'Default Title'
        ? '<p class="vna-cart-item__variant">' + escapeHtml(item.variant_title) + '</p>'
        : '';
      var imageUrl = item.image || '';
      var handle = productHandleFromItem(item);
      var inventory = inventoryStateForCartItem(item);
      var maxQuantity = inventory ? normalizedMaxQuantity(inventory.maxQuantity) : null;
      var variantTotal = variantTotals[String(item.variant_id || '')];
      var lineMax = maxQuantity === null ? null : lineMaxQuantity(item.quantity, maxQuantity, variantTotal);
      var isAtMax = isAtMaxQuantity(item.quantity, lineMax);
      var articleClass = 'vna-cart-item' + (isAtMax ? ' is-at-max' : '');
      var lineEntries = item._vnaLines && item._vnaLines.length ? item._vnaLines : [{ key: item.key, quantity: Number(item.quantity || 0) }];
      var inventoryAttrs = [
        ' data-variant-id="' + escapeHtml(item.variant_id || '') + '"',
        ' data-product-handle="' + escapeHtml(handle) + '"',
        ' data-inventory-managed="' + (inventory && inventory.managed ? 'true' : 'false') + '"',
        ' data-inventory-policy="' + escapeHtml((inventory && inventory.policy) || '') + '"',
        maxQuantity !== null ? ' data-max-quantity="' + maxQuantity + '"' : '',
        lineMax !== null ? ' data-line-max-quantity="' + lineMax + '"' : ''
      ].join('');
      var plusAttrs = ' data-vna-cart-plus' + (isAtMax ? ' aria-hidden="true" disabled' : '');
      if (imageUrl.indexOf('//') === 0) imageUrl = window.location.protocol + imageUrl;
      if (imageUrl && imageUrl.indexOf('width=') === -1) {
        imageUrl += imageUrl.indexOf('?') === -1 ? '?width=220' : '&width=220';
      }
      var image = imageUrl
        ? '<img src="' + escapeHtml(imageUrl) + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">'
        : '';

      return [
        '<article class="' + articleClass + '" data-vna-cart-item data-key="' + escapeHtml(lineEntries[0].key || item.key) + '" data-vna-line-entries="' + escapeHtml(JSON.stringify(lineEntries)) + '"' + inventoryAttrs + ' data-quantity="' + item.quantity + '" data-original-line-price="' + Number(item.original_line_price || item.line_price || 0) + '" data-final-line-price="' + Number(item.final_line_price || item.line_price || 0) + '">',
          '<a class="vna-cart-item__image" href="' + escapeHtml(item.url) + '">' + image + '</a>',
          '<div class="vna-cart-item__content">',
            '<div class="vna-cart-item__top">',
              '<a class="vna-cart-item__title" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a>',
              renderLinePrices(item),
            '</div>',
            variant,
            renderLineDiscounts(item),
            '<div class="vna-cart-item__bottom">',
              '<div class="vna-cart-item__qty" aria-label="' + escapeHtml(t('quantity', 'Quantity')) + '">',
                '<button type="button" data-vna-cart-qty="-1" aria-label="' + escapeHtml(t('decreaseQuantity', 'Decrease quantity')) + '">-</button>',
                '<span>' + item.quantity + '</span>',
                '<button type="button" data-vna-cart-qty="1"' + plusAttrs + ' aria-label="' + escapeHtml(t('increaseQuantity', 'Increase quantity')) + '">+</button>',
              '</div>',
              '<button type="button" class="vna-cart-item__remove" data-vna-cart-remove>' + escapeHtml(t('remove', 'Remove')) + '</button>',
            '</div>',
          '</div>',
        '</article>'
      ].join('');
    }).join('');
  }

  function renderSummaryValues(summary) {
    var subtotal = root.querySelector('[data-vna-cart-subtotal]');
    var total = root.querySelector('[data-vna-cart-total]');
    var discount = root.querySelector('[data-vna-cart-discount]');
    var discountTitles = root.querySelector('[data-vna-cart-discount-titles]');
    var discountRow = root.querySelector('[data-vna-cart-discount-row]');
    if (subtotal) subtotal.textContent = formatMoney(summary.subtotal);
    if (total) total.textContent = formatMoney(summary.total);
    if (discount) discount.textContent = '-' + formatMoney(summary.discount);
    if (discountTitles) discountTitles.textContent = summary.discountTitles.length ? '（' + summary.discountTitles.join('・') + '）' : '';
    if (discountRow) {
      var hasDiscount = summary.discount > 0;
      discountRow.hidden = !hasDiscount;
      discountRow.setAttribute('aria-hidden', hasDiscount ? 'false' : 'true');
      discountRow.style.display = hasDiscount ? '' : 'none';
    }
  }

  function updateSummary(cart) {
    updateCartCount(cart.item_count);
    displayedSummary = {
      subtotal: Number(cart.items_subtotal_price || cart.total_price || 0),
      total: Number(cart.total_price || 0),
      discount: Number(cart.total_discount || 0),
      discountTitles: cartDiscountTitles(cart)
    };
    renderSummaryValues(displayedSummary);
  }

  function updateShipping(cart) {
    var progress = root.querySelector('[data-vna-shipping-progress]');
    var left = root.querySelector('[data-vna-shipping-left]');
    var thresholdText = root.querySelector('[data-vna-shipping-threshold]');
    var threshold = currentFreeShippingThreshold(cart);
    if (!progress || !threshold) return;
    var ratio = Math.min(cart.total_price / threshold, 1);
    var thresholdMoney = formatMoney(threshold);
    progress.style.width = Math.round(ratio * 100) + '%';
    if (thresholdText) thresholdText.textContent = shippingText(freeShippingRightText, thresholdMoney);
    if (left) {
      var remaining = formatMoney(Math.max(threshold - cart.total_price, 0));
      left.textContent = cart.total_price >= threshold
        ? freeShippingCompleteText
        : shippingText(freeShippingLeftText, remaining);
    }
  }

  function updateGift(cart) {
    var modal = root.querySelector('[data-vna-gift-modal]');
    if (!modal || !giftThreshold) return;
    var reached = cart.total_price >= giftThreshold;
    var hasGift = giftVariantId && cart.items.some(function (item) {
      return String(item.variant_id) === String(giftVariantId);
    });
    var progress = root.querySelector('[data-vna-gift-progress]');
    var status = root.querySelector('[data-vna-gift-status]');
    var button = root.querySelector('[data-vna-gift-add]');
    if (progress) progress.style.width = Math.min(cart.total_price / giftThreshold, 1) * 100 + '%';
    if (status) status.textContent = reached ? (hasGift ? giftAddedText : giftReachedText) : giftNotReachedText;
    if (button) {
      button.disabled = !reached || hasGift || !giftVariantId;
      button.textContent = reached && !hasGift ? giftReachedButtonText : giftDisabledButtonText;
    }
  }

  function renderCart(cart) {
    if (!cart || !cart.items) return;
    lastCart = cart;
    renderItems(cart);
    rememberInventoryFromDom();
    updateSummary(cart);
    updateShipping(cart);
    updateGift(cart);
    syncWishlistButtons();
  }

  function refreshCart() {
    return fetchCart().then(function (cart) {
      renderCart(cart);
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart } }));
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { cart: cart } }));
      return cart;
    });
  }

  function closeToolPanels() {
    root.querySelectorAll('[data-vna-tool-panel]').forEach(function (panel) {
      panel.hidden = true;
    });
    root.querySelectorAll('[data-vna-tool-toggle]').forEach(function (button) {
      button.setAttribute('aria-expanded', 'false');
    });
  }

  function toggleToolPanel(name) {
    var panel = root.querySelector('[data-vna-tool-panel="' + name + '"]');
    if (!panel) return;
    var willOpen = panel.hidden;
    closeToolPanels();
    panel.hidden = !willOpen;
    var button = root.querySelector('[data-vna-tool-toggle="' + name + '"]');
    if (button) button.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    if (willOpen) {
      var field = panel.querySelector('input, textarea');
      if (field) window.setTimeout(function () { field.focus(); }, 80);
    }
  }

  function openGiftModal() {
    closeToolPanels();
    var modal = root.querySelector('[data-vna-gift-modal]');
    if (!modal) return;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
  }

  function closeGiftModal() {
    var modal = root.querySelector('[data-vna-gift-modal]');
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
  }

  function getDisplayedQuantity(item) {
    if (!item) return 1;
    var qtyNode = item.querySelector('.vna-cart-item__qty span');
    var value = Number(item.dataset.quantity || (qtyNode ? qtyNode.textContent : 1));
    return Number.isNaN(value) ? 1 : value;
  }

  function lineEntriesFromDomItem(item) {
    if (!item) return [];
    if (item.dataset.vnaLineEntries) {
      try {
        return JSON.parse(item.dataset.vnaLineEntries).filter(function (entry) {
          return entry && entry.key && Number(entry.quantity || 0) > 0;
        }).map(function (entry) {
          return {
            key: String(entry.key),
            quantity: Number(entry.quantity || 0)
          };
        });
      } catch (error) {}
    }

    return item.dataset.key ? [{ key: item.dataset.key, quantity: getDisplayedQuantity(item) }] : [];
  }

  function cartQuantityByVariantFromDom() {
    var totals = Object.create(null);
    if (!itemsNode) return totals;
    itemsNode.querySelectorAll('[data-vna-cart-item]').forEach(function (item) {
      var variantId = item.dataset.variantId;
      if (!variantId) return;
      totals[variantId] = (totals[variantId] || 0) + getDisplayedQuantity(item);
    });
    return totals;
  }

  function lineMaxQuantityForDomItem(item, variantTotals) {
    if (!item) return null;
    var maxQuantity = normalizedMaxQuantity(item.dataset.maxQuantity);
    if (maxQuantity === null) return null;
    var variantId = item.dataset.variantId;
    var variantTotal = variantId && variantTotals ? variantTotals[variantId] : null;
    return lineMaxQuantity(getDisplayedQuantity(item), maxQuantity, variantTotal);
  }

  function applyLineMaxState(item, variantTotals) {
    if (!item) return;
    var maxQuantity = lineMaxQuantityForDomItem(item, variantTotals);
    var atMax = isAtMaxQuantity(getDisplayedQuantity(item), maxQuantity);
    var plusButton = item.querySelector('[data-vna-cart-plus]');
    if (maxQuantity === null) {
      delete item.dataset.lineMaxQuantity;
    } else {
      item.dataset.lineMaxQuantity = String(maxQuantity);
    }
    item.classList.toggle('is-at-max', atMax);
    if (!plusButton) return;
    plusButton.hidden = false;
    plusButton.removeAttribute('hidden');
    plusButton.setAttribute('aria-hidden', atMax ? 'true' : 'false');
    plusButton.disabled = atMax || item.classList.contains('is-line-pending');
    plusButton.setAttribute('aria-disabled', plusButton.disabled ? 'true' : 'false');
  }

  function applyAllLineMaxStates() {
    if (!itemsNode) return;
    var variantTotals = cartQuantityByVariantFromDom();
    itemsNode.querySelectorAll('[data-vna-cart-item]').forEach(function (item) {
      applyLineMaxState(item, variantTotals);
    });
  }

  function rememberInventoryFromDom() {
    if (!itemsNode) return;
    itemsNode.querySelectorAll('[data-vna-cart-item]').forEach(function (item) {
      var variantId = item.dataset.variantId;
      var maxQuantity = normalizedMaxQuantity(item.dataset.maxQuantity);
      if (variantId && maxQuantity !== null) {
        rememberInventoryState(
          variantId,
          maxQuantity,
          item.dataset.inventoryManaged === 'true',
          item.dataset.inventoryPolicy || '',
          item.dataset.productHandle || ''
        );
      } else if (variantId) {
        delete inventoryCache[String(variantId)];
      }
    });
    applyAllLineMaxStates();
  }

  function setLinePending(item, active) {
    if (!item) return;
    if (item.__vnaLinePendingTimer) {
      window.clearTimeout(item.__vnaLinePendingTimer);
      item.__vnaLinePendingTimer = null;
    }
    item.classList.toggle('is-line-pending', Boolean(active));
    item.setAttribute('aria-busy', active ? 'true' : 'false');
    item.querySelectorAll('[data-vna-cart-qty], [data-vna-cart-remove]').forEach(function (button) {
      var maxBlocked = !active && button.hasAttribute('data-vna-cart-plus') && item.classList.contains('is-at-max');
      button.disabled = Boolean(active || maxBlocked);
      button.setAttribute('aria-disabled', button.disabled ? 'true' : 'false');
    });
    if (active) {
      item.__vnaLinePendingTimer = window.setTimeout(function () {
        if (!item.isConnected || !item.classList.contains('is-line-pending')) return;
        recoverLineInteractivity(item);
        setCartCalculating(false);
        refreshCart().catch(function () {
          scheduleCartSettleRefresh();
        });
      }, 15000);
    }
    if (!active) applyAllLineMaxStates();
  }

  function findCartItemByKey(key) {
    var found = null;
    if (!key || !itemsNode) return null;
    itemsNode.querySelectorAll('[data-vna-cart-item]').forEach(function (item) {
      if (item.dataset.key === key) found = item;
      if (!found) {
        lineEntriesFromDomItem(item).forEach(function (entry) {
          if (entry.key === key) found = item;
        });
      }
    });
    return found;
  }

  function lineChangePlan(item, nextQuantity) {
    var entries = lineEntriesFromDomItem(item);
    var currentQuantity = getDisplayedQuantity(item);
    var targetQuantity = Math.max(Number(nextQuantity || 0), 0);
    var delta = targetQuantity - currentQuantity;
    var changes = [];

    if (!entries.length || delta === 0) return changes;

    if (targetQuantity === 0) {
      return entries.map(function (entry) {
        return { key: entry.key, quantity: 0 };
      });
    }

    if (delta > 0) {
      changes.push({
        key: entries[0].key,
        quantity: entries[0].quantity + delta
      });
      return changes;
    }

    var remaining = Math.abs(delta);
    for (var index = entries.length - 1; index >= 0 && remaining > 0; index -= 1) {
      var entry = entries[index];
      var decrease = Math.min(entry.quantity, remaining);
      changes.push({
        key: entry.key,
        quantity: entry.quantity - decrease
      });
      remaining -= decrease;
    }

    return changes;
  }

  function changeLines(changes) {
    if (!changes.length) return Promise.resolve(lastCart);
    if (changes.length === 1) return changeLine(changes[0].key, changes[0].quantity);
    var updates = {};
    changes.forEach(function (change) {
      updates[change.key] = change.quantity;
    });
    return updateLines(updates);
  }

  function dispatchCartEvents(cart) {
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart } }));
    document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { cart: cart } }));
  }

  function requestLineChange(item, nextQuantity) {
    if (!item || item.classList.contains('is-line-pending')) return;
    var key = item.dataset.key;
    var currentQuantity = getDisplayedQuantity(item);
    var requestedQuantity = Number(nextQuantity);
    var quantity = Number.isFinite(requestedQuantity) ? Math.max(requestedQuantity, 0) : currentQuantity;
    if (!key) return;
    if (quantity === currentQuantity && quantity !== 0) return;
    if (quantity > currentQuantity && isAtMaxQuantity(currentQuantity, lineMaxQuantityForDomItem(item, cartQuantityByVariantFromDom()))) {
      applyAllLineMaxStates();
      return;
    }

    var changes = lineChangePlan(item, quantity);
    if (!changes.length) return;

    setCartCalculating(true);
    setLinePending(item, true);
    item.classList.add('is-pricing-pending');

    enqueueCartMutation(function () {
      return withTimeout(
        changeLines(changes),
        12000,
        t('cartUpdateError', 'Cart could not be updated. Please wait a moment and try again.')
      );
    })
      .then(function (cart) {
        renderCart(cart);
        dispatchCartEvents(cart);
      })
      .catch(function (error) {
        markCartBackoff(error);
        setCartStatus(t('cartUpdateError', 'Cart could not be updated. Please wait a moment and try again.'), 'error');
        if (isCartAccessBlocked(error)) {
          scheduleCartSettleRefresh(2600);
          return;
        }
        return refreshCart().catch(function () {
          scheduleCartSettleRefresh();
        });
      })
      .finally(function () {
        var currentItem = findCartItemByKey(key) || item;
        recoverLineInteractivity(currentItem);
        setCartCalculating(false);
      });
  }

  function isCartTrigger(node) {
    if (!node || root.contains(node)) return false;
    if (node.matches('[data-cart-sidebar]')) return true;
    if (!node.matches('a[href]')) return false;
    if (node.target && node.target !== '_self') return false;
    try {
      var path = new URL(node.href, window.location.origin).pathname.replace(/\/$/, '');
      var localizedCartPath = new URL(route('cart'), window.location.origin).pathname.replace(/\/$/, '');
      return path === '/cart' || path === localizedCartPath;
    } catch (error) {
      return false;
    }
  }

  function isCartAddUrl(input) {
    var url = '';
    if (typeof input === 'string') url = input;
    else if (input && input.url) url = input.url;
    if (!url) return false;
    try {
      return /\/cart\/add(?:\.js)?\/?$/.test(new URL(url, window.location.origin).pathname);
    } catch (error) {
      return url.indexOf('/cart/add') !== -1;
    }
  }

  function isCartAddForm(form) {
    if (!form || !form.action) return false;
    return isCartAddUrl(form.action);
  }

  function showFormError(form, message) {
    var errorNode = form.querySelector('[data-vna-cart-form-error]');
    if (!errorNode) {
      errorNode = document.createElement('p');
      errorNode.setAttribute('data-vna-cart-form-error', '');
      errorNode.style.color = '#9a5555';
      errorNode.style.fontSize = '12px';
      errorNode.style.marginTop = '10px';
      form.appendChild(errorNode);
    }
    errorNode.textContent = userCartMessage({ message: message }, t('addToCartError', 'Could not add this item to cart. Please wait a moment and try again.'));
  }

  function submitCartAddForm(form, submitter) {
    if (!form || form.dataset.vnaSubmitting === 'true') return;
    form.dataset.vnaSubmitting = 'true';
    if (submitter) {
      submitter.disabled = true;
      submitter.classList.add('is-loading');
    }

    var formData = new FormData(form);
    if (submitter && submitter.name && !formData.has(submitter.name)) {
      formData.append(submitter.name, submitter.value || '');
    }
    enqueueCartMutation(function () {
      return withTimeout(
        fetchInternalCartAdd({
          method: 'POST',
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
          cache: 'no-store',
          body: formData
        })
          .then(function (response) {
            return parseJsonResponse(response, t('addToCartError', 'Could not add this item to cart. Please wait a moment and try again.'));
          }),
        15000,
        t('addToCartError', 'Could not add this item to cart. Please wait a moment and try again.')
      );
      })
      .then(function () {
        return refreshCartAfterAdd();
      })
      .then(function () {
        closeLegacyPopups();
        openDrawer({ refresh: false });
      })
      .catch(function (error) {
        markCartBackoff(error);
        showFormError(form, userCartMessage(error, t('addToCartError', 'Could not add this item to cart. Please wait a moment and try again.')));
      })
      .finally(function () {
        form.dataset.vnaSubmitting = 'false';
        if (submitter) {
          submitter.disabled = false;
          submitter.classList.remove('is-loading');
        }
      });
  }

  function getCartAddFormFromClick(target) {
    if (!target || root.contains(target)) return null;
    var submitter = target.closest('button, input[type="submit"], input[type="button"]');
    if (!submitter) return null;
    var form = submitter.form || submitter.closest('form');
    if (!isCartAddForm(form)) return null;
    return { form: form, submitter: submitter };
  }

  function fetchProduct(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    }).then(function (response) {
      return response.json().catch(function () { return null; }).then(function (data) {
        if (!response.ok || !data) throw new Error('Unable to load product');
        return data;
      });
    });
  }

  function productOptions(product) {
    var options = product && product.options ? product.options : [];
    return options.map(function (option, index) {
      if (typeof option === 'string') {
        return {
          name: option,
          values: Array.from(new Set((product.variants || []).map(function (variant) {
            return variant['option' + (index + 1)];
          }).filter(Boolean)))
        };
      }
      return {
        name: option.name || ('Option ' + (index + 1)),
        values: option.values || []
      };
    });
  }

  function variantOptions(variant, count) {
    return [variant.option1, variant.option2, variant.option3].slice(0, count).filter(function (value) {
      return value != null && value !== '';
    });
  }

  function findVariant(product, options) {
    var count = productOptions(product).length;
    return (product.variants || []).find(function (variant) {
      var values = variantOptions(variant, count);
      return values.every(function (value, index) { return value === options[index]; });
    }) || null;
  }

  function firstAvailableVariant(product) {
    return (product.variants || []).find(function (variant) { return variant.available; }) || (product.variants || [])[0] || null;
  }

  function productImage(product, variant) {
    var image = variant && variant.featured_image ? (variant.featured_image.src || variant.featured_image) : '';
    image = image || product.featured_image || (product.images && product.images[0]) || '';
    if (image && image.indexOf('//') === 0) image = window.location.protocol + image;
    if (image && image.indexOf('width=') === -1) {
      image += image.indexOf('?') === -1 ? '?width=520' : '&width=520';
    }
    return image;
  }

  function optionValueAvailable(product, optionIndex, value) {
    var testOptions = recState.options.slice();
    testOptions[optionIndex] = value;
    var count = productOptions(product).length;
    return (product.variants || []).some(function (variant) {
      if (!variant.available) return false;
      var values = variantOptions(variant, count);
      return values.every(function (variantValue, index) {
        return !testOptions[index] || testOptions[index] === variantValue;
      });
    });
  }

  function renderRecModal() {
    if (!recModal || !recState.product) return;
    var product = recState.product;
    var options = productOptions(product);
    var variant = findVariant(product, recState.options);
    if (!variant || !variant.available) variant = firstAvailableVariant(product);
    recState.variant = variant;

    var title = recModal.querySelector('[data-vna-rec-title]');
    var image = recModal.querySelector('[data-vna-rec-image]');
    var price = recModal.querySelector('[data-vna-rec-price]');
    var compare = recModal.querySelector('[data-vna-rec-compare]');
    var optionsNode = recModal.querySelector('[data-vna-rec-options]');
    var qtyValue = recModal.querySelector('[data-vna-rec-qty-value]');
    var submit = recModal.querySelector('[data-vna-rec-submit]');
    var error = recModal.querySelector('[data-vna-rec-error]');

    if (title) title.textContent = product.title || '';
    if (image) {
      var imageUrl = productImage(product, variant);
      image.src = imageUrl;
      image.alt = product.title || '';
      image.hidden = !imageUrl;
    }
    if (price) price.textContent = variant ? formatMoney(variant.price) : '';
    if (compare) {
      var showCompare = variant && variant.compare_at_price && variant.compare_at_price > variant.price;
      compare.hidden = !showCompare;
      compare.textContent = showCompare ? formatMoney(variant.compare_at_price) : '';
    }
    if (qtyValue) qtyValue.textContent = recState.quantity;
    if (submit) submit.disabled = !variant || !variant.available;
    if (error) {
      error.hidden = true;
      error.textContent = '';
    }

    if (optionsNode) {
      optionsNode.innerHTML = options.map(function (option, optionIndex) {
        var values = option.values || [];
        return [
          '<div class="vna-rec-modal__group">',
            '<span class="vna-rec-modal__group-label">' + escapeHtml(option.name) + '</span>',
            '<div class="vna-rec-modal__values">',
              values.map(function (value) {
                var active = recState.options[optionIndex] === value;
                var available = optionValueAvailable(product, optionIndex, value);
                return [
                  '<button type="button" class="vna-rec-modal__option' + (active ? ' is-active' : '') + '"',
                    ' data-vna-rec-option data-option-index="' + optionIndex + '" data-option-value="' + escapeHtml(value) + '"',
                    available ? '' : ' disabled',
                  '>',
                    escapeHtml(value),
                  '</button>'
                ].join('');
              }).join(''),
            '</div>',
          '</div>'
        ].join('');
      }).join('');
    }
  }

  function openRecModal(product, sourceButton) {
    var variant = firstAvailableVariant(product);
    var options = productOptions(product);
    recState.product = product;
    recState.options = variant ? variantOptions(variant, options.length) : options.map(function (option) {
      return (option.values || [])[0] || '';
    });
    recState.quantity = 1;
    recState.variant = variant;
    recState.sourceButton = sourceButton || null;
    renderRecModal();
    if (!recModal) return;
    recModal.classList.add('is-open');
    recModal.setAttribute('aria-hidden', 'false');
  }

  function closeRecModal() {
    if (!recModal) return;
    recModal.classList.remove('is-open');
    recModal.setAttribute('aria-hidden', 'true');
  }

  function addRecommendation(button) {
    var handle = button.dataset.productHandle;
    var fallbackVariantId = button.dataset.variantId;
    var variantCount = Number(button.dataset.variantCount || 1);
    var hasOnlyDefault = button.dataset.hasOnlyDefaultVariant === 'true';

    button.disabled = true;
    button.classList.add('is-loading');

    if (variantCount <= 1 || hasOnlyDefault) {
      addVariant(fallbackVariantId, 1)
        .then(function () { openDrawer({ refresh: false }); })
        .catch(function () {})
        .finally(function () {
          button.disabled = false;
          button.classList.remove('is-loading');
        });
      return;
    }

    fetchProduct(handle)
      .then(function (product) {
        var availableVariants = (product.variants || []).filter(function (variant) { return variant.available; });
        if (availableVariants.length <= 1) {
          return addVariant((availableVariants[0] || product.variants[0] || {}).id || fallbackVariantId, 1)
            .then(function () { openDrawer({ refresh: false }); });
        }
        openRecModal(product, button);
      })
      .catch(function () {
        return addVariant(fallbackVariantId, 1)
          .then(function () { openDrawer({ refresh: false }); });
      })
      .finally(function () {
        button.disabled = false;
        button.classList.remove('is-loading');
      });
  }

  function handleRecSubmit() {
    var submit = recModal && recModal.querySelector('[data-vna-rec-submit]');
    var error = recModal && recModal.querySelector('[data-vna-rec-error]');
    var variant = recState.variant || findVariant(recState.product, recState.options);
    if (!variant || !variant.available) return;
    if (submit) {
      submit.disabled = true;
      submit.classList.add('is-loading');
    }
    if (error) error.hidden = true;

    addVariant(variant.id, recState.quantity)
      .then(function () {
        closeRecModal();
        openDrawer({ refresh: false });
      })
      .catch(function (err) {
        if (error) {
          error.textContent = userCartMessage(err, t('addToCartError', 'Could not add this item to cart. Please wait a moment and try again.'));
          error.hidden = false;
        }
      })
      .finally(function () {
        if (submit) {
          submit.disabled = false;
          submit.classList.remove('is-loading');
        }
      });
  }

  function cartHasDiscountCode(cart, code) {
    var target = String(code || '').toLowerCase();
    var applications = []
      .concat(cart.cart_level_discount_applications || [])
      .concat(cart.discount_applications || []);

    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (allocation) {
        if (allocation.discount_application) applications.push(allocation.discount_application);
      });
    });

    return applications.some(function (application) {
      var title = String(application.title || application.code || '').toLowerCase();
      return title && title === target;
    });
  }

  function applyCouponCode() {
    var input = root.querySelector('[data-vna-coupon-input]');
    var code = input ? input.value.trim() : '';
    var beforeDiscount = displayedSummary.discount;

    if (!code) {
      setToolStatus('coupon', t('enterCoupon', 'Enter a coupon code.'), 'error');
      if (input) input.focus();
      return;
    }

    setToolLoading('coupon', true);
    setCartCalculating(true);
    setToolStatus('coupon', t('applyingCoupon', 'Applying...'), 'loading');

    fetch(route('discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(route('cart'))), {
      credentials: 'same-origin',
      headers: { Accept: 'text/html' },
      cache: 'no-store'
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Discount failed');
        return refreshCart();
      })
      .then(function (cart) {
        var applied = cartHasDiscountCode(cart, code) || Number(cart.total_discount || 0) > beforeDiscount;
        setToolStatus('coupon', applied ? t('appliedCoupon', 'Coupon applied.') : t('checkCoupon', 'Please check the code.'), applied ? 'success' : 'error');
        scheduleCartSettleRefresh();
      })
      .catch(function () {
        setCartCalculating(false);
        setToolStatus('coupon', t('couponFailed', 'Coupon could not be applied.'), 'error');
      })
      .finally(function () {
        setToolLoading('coupon', false);
      });
  }

  function saveCartNote() {
    var note = root.querySelector('[data-vna-note-input]');
    setToolLoading('note', true);
    setToolStatus('note', t('noteSaving', 'Saving...'), 'loading');

    fetch(route('cart/update.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      cache: 'no-store',
      body: JSON.stringify({ note: note ? note.value : '' })
    })
      .then(function (response) {
        return parseJsonResponse(response, t('noteFailed', 'Could not save. Please try again.'));
      })
      .then(function (cart) {
        if (cart && cart.items) renderCart(cart);
        setToolStatus('note', t('noteSaved', 'Order note saved.'), 'success');
      })
      .catch(function (error) {
        markCartBackoff(error);
        setToolStatus('note', t('noteFailed', 'Could not save. Please try again.'), 'error');
      })
      .finally(function () {
        setToolLoading('note', false);
      });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-cart-sidebar], a[href]');
    if (isCartTrigger(trigger)) {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (isDrawerOpen()) closeDrawer();
      else openDrawer();
      return;
    }

    if (isDrawerOpen() && !root.contains(event.target)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      closeDrawer();
      return;
    }

    var formInfo = getCartAddFormFromClick(event.target);
    if (formInfo) {
      event.preventDefault();
      event.stopImmediatePropagation();
      submitCartAddForm(formInfo.form, formInfo.submitter);
    }
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || root.contains(form) || !isCartAddForm(form)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    submitCartAddForm(form, form.querySelector('[type="submit"], button[name="add"]'));
  }, true);

  root.addEventListener('click', function (event) {
    var closeButton = event.target.closest('[data-vna-cart-close]');
    if (closeButton) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    var item = event.target.closest('[data-vna-cart-item]');
    if (item) {
      var qtyButton = event.target.closest('[data-vna-cart-qty]');
      if (qtyButton) {
        event.preventDefault();
        if (item.classList.contains('is-line-pending')) return;
        requestLineChange(item, getDisplayedQuantity(item) + Number(qtyButton.dataset.vnaCartQty));
        return;
      }
      if (event.target.closest('[data-vna-cart-remove]')) {
        event.preventDefault();
        if (item.classList.contains('is-line-pending')) return;
        requestLineChange(item, 0);
        return;
      }
    }

    var tool = event.target.closest('[data-vna-tool-toggle]');
    if (tool) {
      event.preventDefault();
      toggleToolPanel(tool.dataset.vnaToolToggle);
      return;
    }

    if (event.target.closest('[data-vna-coupon-apply]')) {
      event.preventDefault();
      applyCouponCode();
      return;
    }

    if (event.target.closest('[data-vna-note-save]')) {
      event.preventDefault();
      saveCartNote();
      return;
    }

    if (event.target.closest('[data-vna-gift-open]')) {
      event.preventDefault();
      openGiftModal();
      return;
    }

    if (event.target.closest('[data-vna-gift-close]')) {
      event.preventDefault();
      closeGiftModal();
      return;
    }

    if (event.target.closest('[data-vna-gift-add]') && giftVariantId) {
      event.preventDefault();
      addVariant(giftVariantId, 1)
        .then(closeGiftModal)
        .catch(function () {
          setToolStatus('gift', t('addToCartError', 'Could not add this item to cart. Please wait a moment and try again.'), 'error');
        });
      return;
    }

    if (event.target.closest('[data-vna-rec-close]')) {
      event.preventDefault();
      closeRecModal();
      return;
    }

    var recOption = event.target.closest('[data-vna-rec-option]');
    if (recOption) {
      event.preventDefault();
      recState.options[Number(recOption.dataset.optionIndex)] = recOption.dataset.optionValue;
      recState.variant = findVariant(recState.product, recState.options);
      renderRecModal();
      return;
    }

    var recQty = event.target.closest('[data-vna-rec-qty]');
    if (recQty) {
      event.preventDefault();
      recState.quantity = Math.max(recState.quantity + Number(recQty.dataset.vnaRecQty), 1);
      renderRecModal();
      return;
    }

    if (event.target.closest('[data-vna-rec-submit]')) {
      event.preventDefault();
      handleRecSubmit();
      return;
    }

    var wishlistButton = event.target.closest('[data-vna-wishlist-toggle]');
    if (wishlistButton) {
      event.preventDefault();
      toggleWishlist(wishlistButton);
      return;
    }

    var recAdd = event.target.closest('[data-vna-rec-add]');
    if (recAdd) {
      event.preventDefault();
      addRecommendation(recAdd);
    }
  });

  document.addEventListener('click', function (event) {
    if (root.contains(event.target)) return;

    var recAdd = event.target.closest('[data-vna-rec-add]');
    if (recAdd) {
      event.preventDefault();
      addRecommendation(recAdd);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    if (recModal && recModal.classList.contains('is-open')) {
      closeRecModal();
      return;
    }
    closeDrawer();
  });

  root.addEventListener('keydown', function (event) {
    if (event.key === 'Enter' && event.target && event.target.matches('[data-vna-coupon-input]')) {
      event.preventDefault();
      applyCouponCode();
    }
  });

  window.addEventListener('storage', function (event) {
    if (['vna:wishlist', 'wishlistList', 'halo-wishlist', 'wishList', 'wishlist'].indexOf(event.key) !== -1) {
      syncWishlistButtons();
    }
  });

  document.addEventListener('cart-update', function (event) {
    if (event.detail && event.detail.items) renderCart(event.detail);
  });
  document.addEventListener('cart:refresh', function (event) {
    if (event.detail && event.detail.items) renderCart(event.detail);
  });
  document.addEventListener('vna:variant-inventory', function (event) {
    rememberInventoryPayload(event.detail);
  });

  function scheduleBridgeCartRefresh() {
    if (cartAddBridgeRefreshTimer) window.clearTimeout(cartAddBridgeRefreshTimer);
    cartAddBridgeRefreshTimer = window.setTimeout(function () {
      refreshCart().then(function () {
        closeLegacyPopups();
        openDrawer({ refresh: false });
      }).catch(function () { scheduleCartSettleRefresh(); });
    }, 160);
  }

  function installHaloBridge() {
    window.halo = window.halo || {};
    if (window.halo.updateSidebarCart && window.halo.updateSidebarCart._vnaBridge) return;
    window.halo.updateSidebarCart = function (cart) {
      closeLegacyPopups();
      if (cart && cart.items) {
        renderCart(cart);
        openDrawer({ refresh: false });
        return;
      }
      refreshCart()
        .then(function () { openDrawer({ refresh: false }); })
        .catch(function () { scheduleCartSettleRefresh(); });
    };
    window.halo.updateSidebarCart._vnaBridge = true;
  }

  function patchCartAddNetwork() {
    if (!window.fetch || window.fetch._vnaCartPatched) return;
    var nativeFetch = window.fetch;
    window.fetch = function () {
      var isAdd = isCartAddUrl(arguments[0]);
      var skipBridge = internalCartAddRequests > 0 || Number(window.__VNAInternalCartAddRequests || 0) > 0;
      return nativeFetch.apply(this, arguments).then(function (response) {
        if (isAdd && response.ok && !skipBridge) scheduleBridgeCartRefresh();
        return response;
      });
    };
    window.fetch._vnaCartPatched = true;
  }

  function patchCartAddXhr() {
    if (!window.XMLHttpRequest || window.XMLHttpRequest.prototype._vnaCartPatched) return;
    var nativeOpen = window.XMLHttpRequest.prototype.open;
    var nativeSend = window.XMLHttpRequest.prototype.send;
    window.XMLHttpRequest.prototype.open = function (method, url) {
      this._vnaCartAddUrl = isCartAddUrl(url);
      return nativeOpen.apply(this, arguments);
    };
    window.XMLHttpRequest.prototype.send = function () {
      if (this._vnaCartAddUrl) {
        this._vnaCartSkipBridge = internalCartAddRequests > 0 || Number(window.__VNAInternalCartAddRequests || 0) > 0;
        this.addEventListener('loadend', function () {
          if (this.status >= 200 && this.status < 300 && !this._vnaCartSkipBridge) {
            scheduleBridgeCartRefresh();
          }
        });
      }
      return nativeSend.apply(this, arguments);
    };
    window.XMLHttpRequest.prototype._vnaCartPatched = true;
  }

  installHaloBridge();
  patchCartAddNetwork();
  patchCartAddXhr();
  rememberInventoryFromDom();
  rememberInventoryPayload({
    variants: window.VNACartVariantInventory ? Object.keys(window.VNACartVariantInventory).map(function (key) {
      return window.VNACartVariantInventory[key];
    }) : []
  });
  syncWishlistButtons();
  updateShipping({
    total_price: Number(root.dataset.cartTotalPrice || 0),
    currency: cartCurrencyCode
  });
  refreshCart();

  var bridgeTimer = window.setInterval(function () {
    bridgeInstallCount += 1;
    installHaloBridge();
    if (bridgeInstallCount > 30) window.clearInterval(bridgeTimer);
  }, 250);
})();
